<template>
  <div class="template-management">
    <subfield>
        <template slot="list">
            <el-menu
                default-active="/system/TemplateManagement/ProgramTemplate"
                class="el-menu-vertical-demo"
                :router="true">
                <el-menu-item index="/system/TemplateManagement/ProgramTemplate">
                    <i class="el-icon-setting"></i>
                    <span slot="title">节目模板管理</span>
                </el-menu-item>
                <el-menu-item index="/system/TemplateManagement/Material">
                    <i class="el-icon-setting"></i>
                    <span slot="title">素材库管理</span>
                </el-menu-item>
                <el-menu-item index="/system/TemplateManagement/Font">
                    <i class="el-icon-setting"></i>
                    <span slot="title">字体库管理</span>
                </el-menu-item>
                <el-menu-item index="/system/TemplateManagement/WebTools">
                    <i class="el-icon-setting"></i>
                    <span slot="title">网页工具</span>
                </el-menu-item>
            </el-menu>
        </template>
        <template slot="content">
            <div class="contents" style="height: 100%;">
                <router-view></router-view>
            </div>
        </template>
    </subfield>
  </div>
</template>

<script>
import subfield from '@/components/basics/Subfield'

export default {
    name: 'TemplateManagement',
    data() {
        return {
            // manageList: ['节目模板管理', '素材库管理', '字体库管理']
        }
    },
    created() {
        this.$router.push({
            path:"/system/TemplateManagement/ProgramTemplate"
        })
    },
    methods: {
        
    },
    components: {
        subfield
    }
}
</script>

<style lang="scss" scoped>
    .template-management {
        width: 100%;
        height: 100%;
    }

</style>